import { toast } from "react-toastify";

import { api } from "~/utils/api";

export const useCommunityURLChecker = () => {
    const checkIfCommunityExists =
        api.community.checkIfCommunityExists.useMutation();

    const isCommunityURLTaken = async (
        communitySlug: string,
    ): Promise<boolean | undefined> => {
        try {
            const toastId = toast.loading("Checking community URL...");
            const doesCommunityExist = await checkIfCommunityExists.mutateAsync(
                {
                    communitySlug,
                },
            );

            if (doesCommunityExist) {
                toast.update(toastId, {
                    type: "error",
                    render: "URL already taken! Pick a different URL.",
                    autoClose: 1200,
                    isLoading: false,
                });

                return true;
            }

            toast.update(toastId, {
                type: "success",
                render: "URL is available!",
                autoClose: 1200,
                isLoading: false,
            });

            return false;
        } catch (error) {
            toast.error(
                "An error occurred while checking the community. Please try again.",
            );
            console.error("Error checking community:", error);
        }
    };

    return { isCommunityURLTaken };
};
